module.exports = __webpack_public_path__ + "img/car.5814083c.svg";